export interface TabAggregationTimeOptions {
    useGlobalAggregation: boolean;
}

const defaultTabOptions: TabAggregationTimeOptions = {
    useGlobalAggregation: false,
};

export { defaultTabOptions };
